export const isValidTva = (tva: string) => {
  const regex = /^FR\s*\d{2}\s*\d{3}\s*\d{3}\s*\d{3}$/g;
  return regex.test(tva);
};
